import { render, staticRenderFns } from "./FestivalHistory.vue?vue&type=template&id=0ec34442&scoped=true"
import script from "./FestivalHistory.vue?vue&type=script&lang=js"
export * from "./FestivalHistory.vue?vue&type=script&lang=js"
import style0 from "./FestivalHistory.vue?vue&type=style&index=0&id=0ec34442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec34442",
  null
  
)

export default component.exports